import { createSelector } from 'reselect';
import { databaseId as databaseIdSelector } from '@Selectors/StateParamsSelectors';
import { breadcrumbsReducerKey } from './BreadcrumbsConstants';

export function breadcrumbsState(state) {
  return state.get(breadcrumbsReducerKey);
}

export function breadcrumbsItems(state) {
  return breadcrumbsState(state).get('items');
}

export function breadcrumbsIds(state) {
  return breadcrumbsState(state).get('ids');
}

export function breadcrumbsOrder(state) {
  return breadcrumbsState(state).get('breadcrumbsOrder');
}

function breadcrumbIdFromProps(state, ownProps) {
  return ownProps.id;
}

export function breadcrumbById(state, ownProps) {
  const id = breadcrumbIdFromProps(state, ownProps);
  return breadcrumbsItems(state).get(id);
}

export function breadcrumbsActiveItemGroup(state) {
  const items = breadcrumbsState(state).get('items');
  const activeItem = items.find((item) => !!item.get('active'));
  return activeItem ? activeItem.get('groupId') : null;
}

export const breadcrumbsIdsWithOrder = createSelector(
  [breadcrumbsIds, breadcrumbsItems, breadcrumbsOrder, breadcrumbsActiveItemGroup],
  // eslint-disable-next-line no-shadow
  (breadcrumbsIds, breadcrumbsItems, breadcrumbsOrder, breadcrumbsActiveItemGroup) => {
    let sorted;

    switch (breadcrumbsOrder) {
      case 'desktop':
        sorted = breadcrumbsIds
          .filter((id) => breadcrumbsItems.getIn([id, 'groupId']) === breadcrumbsActiveItemGroup)
          .sortBy(
            (id) => breadcrumbsItems.getIn([id, 'creationTime']),
            (a, b) => b - a
          );
        break;
      case 'tablet':
        sorted = breadcrumbsIds
          .filter((id) => breadcrumbsItems.getIn([id, 'groupId']) === breadcrumbsActiveItemGroup)
          .sortBy(
            (id) => breadcrumbsItems.getIn([id, 'creationTime']),
            (a, b) => a - b
          );
        break;
      default:
        sorted = breadcrumbsIds.filter((id) => breadcrumbsItems.getIn([id, 'groupId']) === breadcrumbsActiveItemGroup);
    }

    return sorted;
  }
);

export function isBackToQueryVisible(state, ownProps) {
  const breadcrumb = breadcrumbById(state, ownProps);
  return (
    !breadcrumb.get('batchSearch') &&
    ((breadcrumb.get('isHistoryBreadcrumb') &&
      (breadcrumb.get('historyType') === 'queryBuilder' || !!breadcrumb.getIn(['quickSearchItem', 'whereClauseImportToken']))) ||
      (!breadcrumb.get('isHistoryBreadcrumb') &&
        (breadcrumb.get('historyType') === 'queryBuilder' || breadcrumb.get('historyType') === 'quickSearch')))
  );
}

export function isBackToQueryBuilder(state, ownProps) {
  const breadcrumb = breadcrumbById(state, ownProps);
  return !!(breadcrumb.get('isFromAdvancedSearch') || breadcrumb.get('isHistoryBreadcrumb'));
}

// eslint-disable-next-line no-shadow
export const activeBreadcrumbForDb = createSelector([breadcrumbsItems, databaseIdSelector], (breadcrumbsItems, databaseId) => {
  return breadcrumbsItems.find((item) => item.get('active') && item.get('databaseId') === databaseId);
});

// eslint-disable-next-line no-shadow
export const rootBreadcrumbForDb = createSelector([breadcrumbsItems, databaseIdSelector], (breadcrumbsItems, databaseId) =>
  breadcrumbsItems.find((item) => item.get('databaseId') === databaseId)
);

export const activeBreadCrumbTotalResult = createSelector([activeBreadcrumbForDb], (activeBreadCrumb) => {
  if (!activeBreadCrumb) {
    return null;
  }

  return activeBreadCrumb.get('totalResult');
});

// Patent Family Clustering
export const activeBreadCrumbRecordCount = createSelector([activeBreadcrumbForDb], (activeBreadCrumb) => {
  if (!activeBreadCrumb) {
    return null;
  }

  return activeBreadCrumb.get('recordCount');
});

export const activeBreadCrumbContext = createSelector([activeBreadcrumbForDb], (activeBreadCrumb) => {
  if (!activeBreadCrumb) {
    return null;
  }

  return activeBreadCrumb.get('context');
});
